// Group categories — single source of truth for labels & accents.
export const GROUP_CATS = [
  { key: "namasmarana", deva: "नामस्मरण", en: "Namasmarana", accent: "#C75000" },
  { key: "deity", deva: "इष्ट देव", en: "Deity", accent: "#A21CAF" },
  { key: "topic", deva: "विषय", en: "Topic", accent: "#1D4ED8" },
  { key: "region", deva: "क्षेत्र", en: "Region", accent: "#047857" },
  { key: "purpose", deva: "संकल्प", en: "Purpose", accent: "#B45309" },
  { key: "general", deva: "सामान्य", en: "General", accent: "#57534E" },
];

export const catMeta = (key) => GROUP_CATS.find((c) => c.key === key) || GROUP_CATS[5];
